import '../user-common-js';

import '../../source/javascripts/main';
import '../../source/javascripts/vcet';
import '../../source/javascripts/vendor/fullcalendar-2.9.1/fullcalendar';

import '../user-common-js/legacy/utilizationtimeInfo';



// WEBPACK FOOTER //
// ./es6/user-page-js/default.page.js